import SubjectAreaController from './subjectAreaController';

const SubjectAreaComponent = {
    template: require('./subjectAreaView.html'),
    controller: SubjectAreaController,
};

SubjectAreaController.$inject = [
    'EvaluationService',
    'StepLearningGoalsService',
    'LearningAreaService',
    'CurriculumService',
    'UserService',
    '$stateParams',
    '$state',
    '$mdDialog',
    '$mdToast',
    '$q',
];

export default SubjectAreaComponent;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningGoals/pages/subjectArea/subjectAreaComponent.js